import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";
import Alert, { AlertState } from "../../../../elements/Alert";
import { VerticalSpacing } from "../../../../elements";
import { VerticalSpacingSizes } from "../../../../core/types";

var TextControl = function TextControl(_ref) {
  var _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? "" : _ref$defaultValue,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$hashableIdentifi = _ref.hashableIdentifier,
      hashableIdentifier = _ref$hashableIdentifi === void 0 ? false : _ref$hashableIdentifi,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "" : _ref$id,
      _ref$labelText = _ref.labelText,
      labelText = _ref$labelText === void 0 ? "" : _ref$labelText,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "" : _ref$name,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? true : _ref$required,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "text" : _ref$type,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? "" : _ref$value,
      _ref$onBlur = _ref.onBlur,
      onBlur = _ref$onBlur === void 0 ? function () {} : _ref$onBlur,
      isError = _ref.isError,
      describedby = _ref.describedby,
      errorMessage = _ref.errorMessage,
      placeholder = _ref.placeholder,
      _ref$optionalText = _ref.optionalText,
      optionalText = _ref$optionalText === void 0 ? "(Optional)" : _ref$optionalText,
      descriptionText = _ref.descriptionText,
      _ref$errorFormat = _ref.errorFormat,
      errorFormat = _ref$errorFormat === void 0 ? "plainText" : _ref$errorFormat;
  var getClassName = getClassNameFactory(TextControl.displayName);
  var attributes = {};

  if (hashableIdentifier) {
    attributes["data-hashable-identifier"] = hashableIdentifier;
  }

  var errorHasHtmlContent = errorFormat === "htmlContent";
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName()
  }, /*#__PURE__*/React.createElement(VerticalSpacing, {
    size: VerticalSpacingSizes.XS
  }, /*#__PURE__*/React.createElement("label", {
    className: getClassName({
      descendantName: "label"
    }),
    htmlFor: id
  }, /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "labelText"
    })
  }, labelText, " ", !required && /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "optional"
    })
  }, optionalText)), descriptionText && /*#__PURE__*/React.createElement("span", {
    className: getClassName({
      descendantName: "descriptionText"
    })
  }, descriptionText), /*#__PURE__*/React.createElement("input", _extends({
    className: getClassName({
      descendantName: "input",
      modifiers: isError && "error"
    }),
    disabled: disabled,
    id: id,
    name: name,
    onChange: onChange,
    type: type,
    value: value || defaultValue,
    onBlur: onBlur,
    placeholder: placeholder,
    "aria-required": required,
    "aria-invalid": isError,
    "aria-describedby": describedby
  }, attributes)))), isError && /*#__PURE__*/React.createElement(VerticalSpacing, {
    size: VerticalSpacingSizes.XS
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Alert, {
    alertState: AlertState.FAILURE,
    id: describedby
  }, errorMessage && (errorHasHtmlContent ? /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: errorMessage
    }
  }) : errorMessage)))));
};

TextControl.displayName = "Form.TextControl";
export default TextControl;